import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a66d7d44")

_pushScopeId("data-v-a66d7d44")
const _hoisted_1 = { class: "editor" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { class: "input-header" }, "Team name", -1)
const _hoisted_3 = {
  key: 0,
  class: "warning"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "exclamation-triangle",
  class: "svg-inline--fa fa-exclamation-triangle fa-w-18",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" There is already a team with this name ")
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "input-header" }, "Type", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Create a team for the entire course")
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Create a team for one or more sections")
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { class: "input-header" }, "Sections to link to this team", -1)
const _hoisted_12 = {
  key: 3,
  class: "input-header"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" There is a maximum of 30 private channels per team. Please note that channels that have been deleted less than 30 days ago are also counted. ")
const _hoisted_14 = { key: 4 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" For each section ")
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { class: "input-header" }, "Options", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Allow all team members to create channels ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Allow all team members to create private channels ")
const _hoisted_19 = { style: {"display":"inline-block","margin-right":"3px"} }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Add all lecturers to the team ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Uncheck this box if you want to be added as the only lecturer to the team. ")
const _hoisted_22 = {
  key: 5,
  class: "link-container"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Use this option to manage the team and private channels for sections or groups. You can add and remove members and delete channels. ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Become owner")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Are you sure you want to become owner of the team? Note that adding/removing members or deleting channels may break synchronization from the learning environment. ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("I understand the risks")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h2", null, _toDisplayString(_ctx.team.url ? "Edit" : "New") + " team", 1),
      _hoisted_2,
      _createVNode("div", null, [
        _withDirectives(_createVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.team.name = $event))
        }, null, 512), [
          [_vModelText, _ctx.team.name]
        ])
      ]),
      (_ctx.isDuplicate)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      _hoisted_6,
      _createVNode("label", null, [
        _withDirectives(_createVNode("input", {
          type: "radio",
          value: _ctx.ContextType.Course,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.team.contexts[0].type = $event))
        }, null, 8, ["value"]), [
          [_vModelRadio, _ctx.team.contexts[0].type]
        ]),
        _hoisted_7
      ]),
      (_ctx.course.sections.length > 1)
        ? (_openBlock(), _createBlock("label", _hoisted_8, [
            _withDirectives(_createVNode("input", {
              type: "radio",
              value: _ctx.ContextType.Section,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.team.contexts[0].type = $event)),
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.team.createSectionChannels = false))
            }, null, 40, ["value"]), [
              [_vModelRadio, _ctx.team.contexts[0].type]
            ]),
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      (_ctx.team.contexts[0].type == _ctx.ContextType.Section)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _hoisted_11,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sections, (sec) => {
              return (_openBlock(), _createBlock("label", {
                key: sec.name
              }, [
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": ($event: any) => (sec.checked = $event)
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelCheckbox, sec.checked]
                ]),
                _createTextVNode(" " + _toDisplayString(sec.name), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedSections.length > 1 || _ctx.course.groupSets.length > 0)
        ? (_openBlock(), _createBlock("label", _hoisted_12, [
            _createTextVNode("Create private channels (" + _toDisplayString(_ctx.channelCount) + "/30) ", 1),
            _createVNode(_component_Tooltip, null, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedSections.length > 1)
        ? (_openBlock(), _createBlock("label", _hoisted_14, [
            _withDirectives(_createVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.team.createSectionChannels = $event)),
              disabled: _ctx.team.createSectionChannels && _ctx.hasSectionChannels
            }, null, 8, ["disabled"]), [
              [_vModelCheckbox, _ctx.team.createSectionChannels]
            ]),
            _hoisted_15
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groupSets, (set) => {
        return (_openBlock(), _createBlock("label", {
          key: set.name
        }, [
          _withDirectives(_createVNode("input", {
            type: "checkbox",
            disabled: set.disabled,
            "onUpdate:modelValue": ($event: any) => (set.checked = $event)
          }, null, 8, ["disabled", "onUpdate:modelValue"]), [
            [_vModelCheckbox, set.checked]
          ]),
          _createTextVNode(" For each group in the category " + _toDisplayString(set.name), 1)
        ]))
      }), 128)),
      _hoisted_16,
      _createVNode("label", null, [
        _withDirectives(_createVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.team.allowChannels = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.team.allowChannels]
        ]),
        _hoisted_17
      ]),
      _createVNode("label", null, [
        _withDirectives(_createVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.team.allowPrivateChannels = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.team.allowPrivateChannels]
        ]),
        _hoisted_18
      ]),
      _createVNode("label", _hoisted_19, [
        _withDirectives(_createVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.team.addAllLecturers = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.team.addAllLecturers]
        ]),
        _hoisted_20
      ]),
      _createVNode(_component_Tooltip, null, {
        default: _withId(() => [
          _hoisted_21
        ]),
        _: 1
      }),
      (_ctx.team.url && _ctx.canBecomeOwner && _ctx.team.isMember)
        ? (_openBlock(), _createBlock("div", _hoisted_22, [
            _createVNode("a", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isOwnerDialog = true)),
              href: "#",
              style: {"display":"inline-block","margin-right":"3px"}
            }, "Become team owner"),
            _createVNode(_component_Tooltip, null, {
              default: _withId(() => [
                _hoisted_23
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _createVNode("button", {
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
          disabled: (_ctx.team.contexts[0].type == _ctx.ContextType.Section && _ctx.sections.filter(s => s.checked).length == 0) || _ctx.team.name.trim().length < 2
        }, _toDisplayString(_ctx.team.url ? "Update" : "Create team"), 9, ["disabled"]),
        _createVNode("button", {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close'))),
          class: "button-secondary"
        }, "Cancel"),
        (_ctx.team.url)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isDeleting = true)),
              class: "button-secondary"
            }, "Delete team"))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isSaving)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.isDeleting)
      ? (_openBlock(), _createBlock(_component_ConfirmDialog, {
          key: 1,
          onConfirm: _ctx.deleteTeam,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isDeleting = false))
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.isOwnerDialog)
      ? (_openBlock(), _createBlock(_component_ConfirmDialog, {
          key: 2,
          onConfirm: _ctx.becomeOwner,
          onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isOwnerDialog = false))
        }, {
          header: _withId(() => [
            _hoisted_24
          ]),
          default: _withId(() => [
            _hoisted_25
          ]),
          confirm: _withId(() => [
            _hoisted_26
          ]),
          _: 1
        }, 8, ["onConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
})